/**
 * Bien choisir son vêtement — interactions (contenu Liquid).
 * Page DISTINCTE de guide-tailles (FAQ volets).
 */
(function () {
  function init(root) {
    if (!root || root.dataset.bcvReady === '1') return;
    root.dataset.bcvReady = '1';

    var mq = window.matchMedia('(max-width:899px)');
    var tabs = root.querySelector('[data-adv-tabs]');
    var panels = root.querySelectorAll('[data-adv-panel]');
    var sel = root.querySelector('[data-adv-select]');
    var selBtn = sel && sel.querySelector('[data-sel-btn]');
    var selLabel = root.querySelector('[data-sel-label]');
    var selList = sel && sel.querySelector('[data-sel-list]');
    var sizeRows = root.querySelectorAll('[data-size-row]');
    var chips = root.querySelector('[data-sp-chips]');
    var card = root.querySelector('[data-sp-card]');
    var fullTable = root.querySelector('[data-full-table]');
    var aiCta = root.querySelector('[data-ai-cta]');
    var subnavLinks = root.querySelectorAll('.subnav a:not(.end)');

    function updateStickyTop() {
      var header =
        document.querySelector('header-component') ||
        document.querySelector('#header-group header') ||
        document.querySelector('.header') ||
        document.querySelector('#header-group');
      var top = 0;
      if (header) {
        var r = header.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) {
          top = Math.max(0, Math.round(r.bottom));
        }
      }
      root.style.setProperty('--bcv-sticky-top', top + 'px');
      return top;
    }

    function scrollOffset() {
      var sticky = updateStickyTop();
      var sub = root.querySelector('.subnav');
      var subH = sub && !mq.matches ? sub.offsetHeight : 0;
      return sticky + subH + (mq.matches ? 8 : 8);
    }

    function scrollToEl(el, offset) {
      if (!el) return;
      var y = el.getBoundingClientRect().top + window.scrollY - (offset != null ? offset : scrollOffset());
      window.scrollTo({ top: y, behavior: 'smooth' });
    }

    function setSituation(i, anim) {
      if (i < 0 || i >= panels.length) return;

      if (tabs) {
        tabs.querySelectorAll('[data-i]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(+b.dataset.i === i));
        });
      }
      if (selList) {
        selList.querySelectorAll('[data-i]').forEach(function (b) {
          b.setAttribute('aria-selected', String(+b.dataset.i === i));
        });
      }
      if (selLabel && panels[i]) {
        selLabel.textContent = panels[i].dataset.label || '';
      }
      panels.forEach(function (p, idx) {
        var on = idx === i;
        p.hidden = !on;
        if (on && anim) {
          p.classList.remove('swap');
          void p.offsetWidth;
          p.classList.add('swap');
        }
      });
    }

    if (tabs) {
      tabs.addEventListener('click', function (e) {
        var b = e.target.closest('[data-i]');
        if (b) setSituation(+b.dataset.i, true);
      });
    }

    if (sel && selBtn && selList) {
      function setOpen(o) {
        sel.classList.toggle('open', o);
        selBtn.setAttribute('aria-expanded', String(o));
      }
      selBtn.addEventListener('click', function () {
        setOpen(!sel.classList.contains('open'));
      });
      selList.addEventListener('click', function (e) {
        var b = e.target.closest('[data-i]');
        if (!b) return;
        setSituation(+b.dataset.i, true);
        setOpen(false);
      });
      document.addEventListener(
        'pointerdown',
        function (e) {
          if (!sel.contains(e.target)) setOpen(false);
        },
        true
      );
    }

    updateStickyTop();
    window.addEventListener('scroll', updateStickyTop, { passive: true });
    window.addEventListener('resize', updateStickyTop);

    root.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href.length < 2) return;
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      scrollToEl(target);
    });

    if (subnavLinks.length) {
      var secs = Array.prototype.map.call(subnavLinks, function (l) {
        return document.querySelector(l.getAttribute('href'));
      });
      function onScroll() {
        var y = window.scrollY + 140;
        var idx = -1;
        secs.forEach(function (s, i) {
          if (s && s.offsetTop <= y) idx = i;
        });
        subnavLinks.forEach(function (l, i) {
          l.classList.toggle('is-active', i === idx);
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    var labels = {
      eq: (card && card.dataset.labelEq) || 'Équivalence',
      bust: (card && card.dataset.labelBust) || 'Poitrine',
      waist: (card && card.dataset.labelWaist) || 'Taille',
      hips: (card && card.dataset.labelHips) || 'Hanches',
      unit: (card && card.dataset.unit) || 'cm',
    };

    function setSize(i) {
      if (chips) {
        chips.querySelectorAll('[data-i]').forEach(function (b) {
          b.classList.toggle('on', +b.dataset.i === i);
        });
      }
      var row = root.querySelector('[data-size-row][data-i="' + i + '"]');
      if (card && row) {
        var u = ' ' + labels.unit;
        card.innerHTML =
          '<div class="sp-row"><span>' +
          labels.eq +
          '</span><b>' +
          (row.dataset.eq || '') +
          '</b></div><div class="sp-row"><span>' +
          labels.bust +
          '</span><b>' +
          (row.dataset.bust || '') +
          u +
          '</b></div><div class="sp-row"><span>' +
          labels.waist +
          '</span><b>' +
          (row.dataset.waist || '') +
          u +
          '</b></div><div class="sp-row"><span>' +
          labels.hips +
          '</span><b>' +
          (row.dataset.hips || '') +
          u +
          '</b></div>';
      }
    }

    if (chips) {
      chips.addEventListener('click', function (e) {
        var b = e.target.closest('[data-i]');
        if (b) setSize(+b.dataset.i);
      });
    }

    var defaultSize = root.dataset.defaultSize != null ? +root.dataset.defaultSize : 2;
    if (sizeRows.length && chips) setSize(Math.min(defaultSize, sizeRows.length - 1));

    if (fullTable) {
      var syncFt = function () {
        fullTable.open = !mq.matches;
      };
      syncFt();
      mq.addEventListener('change', syncFt);
      var summary = fullTable.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function (e) {
          if (!mq.matches) e.preventDefault();
        });
      }
    }

    if (aiCta) {
      aiCta.addEventListener('click', function () {
        var modal = document.getElementById('search-modal');
        if (modal && typeof modal.showDialog === 'function') {
          modal.showDialog();
          requestAnimationFrame(function () {
            var input = modal.querySelector('input[type="search"], input[name="q"], input[type="text"]');
            if (input) input.focus();
          });
          return;
        }
        var trigger = document.querySelector('.search-modal__button, [aria-controls="search-modal"]');
        if (trigger) trigger.click();
      });
    }

    setSituation(0, false);
  }

  function boot() {
    document.querySelectorAll('[data-bcv]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-bcv]');
    if (root) {
      delete root.dataset.bcvReady;
      init(root);
    }
  });
})();
